module.exports = __webpack_public_path__ + "img/maletin-default.1194c772.webp";